<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <g>
    <rect width="64" height="64" fill="none"/>
    <g>
      <g>
        <circle class="filled" cx="21.96" cy="53.36" r="4.048" fill="#304266"/>
        <circle class="filled" cx="45.282" cy="53.36" r="4.048" fill="#304266"/>
      </g>
      <path class="filled" d="M21.455,42.364a.585.585,0,0,1-.034-.585l1.854-3.853H47.607a3.33,3.33,0,0,0,3.109-2.139L56.568,20.5A1.11,1.11,0,0,0,55.531,19H20.466l-2.608-6.384a3.25,3.25,0,0,0-3.009-2.021H9.588a2.2,2.2,0,0,0-2.2,1.762,2.118,2.118,0,0,0,2.088,2.473h3.448l7.709,19.631-2.646,5.5a4.643,4.643,0,0,0-.191,3.755,4.485,4.485,0,0,0,4.173,2.82H48.889a1.942,1.942,0,0,0,1.943-1.942h0a1.943,1.943,0,0,0-1.943-1.943H21.968A.585.585,0,0,1,21.455,42.364Z" fill="#304266"/>
    </g>
  </g>
</svg>
